import { getServerConfig } from '@app/origami-api/server-config';

export class ValidationRegex {
  static readonly url = /(http|https):\/\/(\w+:?\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%\-\/]))?/;
  static get email(): RegExp {
    return getServerConfig().EmailValidationRegexp;
  }

  /**
   * The HTML `pattern` attribute is compiled by browsers as a unicode-mode regex, which rejects
   * backslash-escapes of characters that aren't regex syntax characters (e.g. `\@`). Server-configured
   * email patterns may contain such escapes, so strip the unnecessary ones before using the pattern
   * as an attribute value; use `email` (the RegExp) for actual matching instead.
   */
  static get emailPatternSource(): string {
    return ValidationRegex.email.source.replace(/\\([^\^$.*+?()[\]{}|/\\])/g, '$1');
  }

  static readonly phone = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/i;
  static readonly folderNameReserved = /^[^<>:"\/\\\|\?\*]*[^.<>:"\/\\\|\?\*]$/;
}
